<div class="scan-barcode">
  <app-centered-scrollable-content>

    <sc-flex vertical [centered]="true" stretchContent>
      <sc-sub-title>
        <sc-dictionary-label [dictionaryKey]="messageDictionaryKey"></sc-dictionary-label>
      </sc-sub-title>

      <sc-content-spacer vertical></sc-content-spacer>

      @if (validationMessage != null) {
        <sc-sub-title>
          <sc-dictionary-label [dictionaryKey]="validationMessage.message"></sc-dictionary-label>
        </sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
      }
      @if (showHint) {
        <div>
          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.barcode-scan.hint"></sc-dictionary-label>
        </div>
      }

    </sc-flex>
  </app-centered-scrollable-content>
</div>
